// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Remarks = styled<any, Theme>('span')`
  color: ${props => props.theme.carblock.remarks.color};
  font-size: ${props => props.theme.carblock.remarks.fontSize};
`;

export default Remarks;
